import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface DisplayComplianceFilters {
    regionId: number[] | null; // Assuming region is an array of numbers
    regionName: string[] | null; // Assuming region name is an array of strings
    countryId: number[] | null;
    countryName: string[] | null;
    accountId: number[] | null;
    accountName: string[] | null;
    channelId: number[] | null;
    channelName: string[] | null;
    month: number | null; // Assuming month is a number (1-12)
    year: number | null; // Assuming year is a number (e.g., 202
    storeId: number[] | null; // Assuming store is a number
    storeName: string[] | null; // Assuming store name is a string
    brandId: number[] | null;
    brandName: string[] | null;
}

@Injectable({
    providedIn: 'root'
})
export class DisplayComplianceFilterService {
    private filtersSubject = new BehaviorSubject<DisplayComplianceFilters>({
        regionId: null,
        regionName: null,
        countryId: null,
        countryName: null,
        accountId: null,
        accountName: null,
        channelId: null,
        channelName: null,
        month: null,
        year: null,
        storeId: null,
        storeName: null,
        brandId: null,
        brandName: null
    });

    public filters$: Observable<DisplayComplianceFilters> = this.filtersSubject.asObservable();

    constructor() { }

    // Update country filter
    updateCountryFilter(countryId: number[] | null, countryName: string[] | null) {
        const currentFilters = this.filtersSubject.value;
        const newFilters = {
            ...currentFilters,
            countryId,
            countryName
        };
        this.filtersSubject.next(newFilters);
    }

    // Update account filter
    updateAccountFilter(accountId: number[] | null, accountName: string[] | null) {
        const currentFilters = this.filtersSubject.value;
        this.filtersSubject.next({
            ...currentFilters,
            accountId,
            accountName
        });
    }

    // Update channel filter
    updateChannelFilter(channelId: number[] | null, channelName: string[] | null) {
        const currentFilters = this.filtersSubject.value;
        this.filtersSubject.next({
            ...currentFilters,
            channelId,
            channelName
        });
    }

    // Update month and year filters
    updateMonthYearFilter(month: number | null, year: number | null) {
        const currentFilters = this.filtersSubject.value;
        this.filtersSubject.next({
            ...currentFilters,
            month,
            year
        });
    }

    // Update store filters
    updateStoreFilter(storeId: number[] | null, storeName: string[] | null) {
        const currentFilters = this.filtersSubject.value;
        this.filtersSubject.next({
            ...currentFilters,
            storeId,
            storeName
        });
    }

    // Update store filters
    updateRegionFilter(regionId: number[] | null, regionName: string[] | null) {
        const currentFilters = this.filtersSubject.value;
        this.filtersSubject.next({
            ...currentFilters,
            regionId,
            regionName
        });
    }

    // Get current filters
    getCurrentFilters(): DisplayComplianceFilters {
        return this.filtersSubject.value;
    }

    /** Apply multiple filter fields in a single emission (avoids reload loops). */
    patchFilters(updates: Partial<DisplayComplianceFilters>): void {
        this.filtersSubject.next({
            ...this.filtersSubject.value,
            ...updates,
        });
    }

    // Clear all filters
    clearAllFilters() {
        this.filtersSubject.next({
            regionId: null,
            regionName: null,
            countryId: null,
            countryName: null,
            accountId: null,
            accountName: null,
            channelId: null,
            channelName: null,
            month: null,
            year: null,
            storeId: null,
            storeName: null,
            brandId: null,
            brandName: null
        });
    }
} 